import ProviderTypeTransformer from '../../transformers/providerType';
import axios from 'axios';

export default () => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'providers/provider-types?paginate=false')
      .then(({ data }) => {
        const providerTypes = [];

        if (data.data) {
          data.data.forEach((type) => {
            providerTypes.push(ProviderTypeTransformer.fetch(type));
          });
        }
        resolve(providerTypes);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
